var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.129 22.477c-.418.466-.743.623-1.129.623-.39 0-.72-.15-.994-.44zM10 .9c.25 0 .463.064.62.232.166.18.241.4.241.656v1.565c2.031.457 3.378 1.281 4.43 2.602.987 1.24 1.48 2.66 1.48 4.257v6.939l1.986 2.066-17.794.29 2.267-2.356v-6.923c.066-1.777.55-3.105 1.48-4.273C5.844 4.529 7.32 3.673 9.139 3.39V1.822c.025-.316.087-.524.242-.69C9.537.964 9.749.9 10 .9z",
    fillRule: "nonzero",
    stroke: "#272726",
    strokeWidth: 1.8,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.46b079cdd8e89369f01bc8a67ee44fcd.svg";
export { ForwardRef as ReactComponent };